import React, { useState, createContext, useEffect, useContext, useMemo } from "react";
import NotFound from "../notFound/NotFound";
import DashboardTemplate from "./components/templates/DashboardTemplate";
import "../../style/dashboardGraph.css";
import BaseApi from "../../functions/axios";
import { globalContext } from "../../App";

export const dashboardContext = createContext({});

function DashboardContent() {
  const { rerendering } = useContext(globalContext);
  const [newMatchingList, setNewMatchingList] = useState([]);
  const [activeMatchingList, setActiveMatchingList] = useState([]);
  const [notification, setNotification] = useState([]);
  const [topSummaryList, setTopSummaryList] = useState([]);
  const [conditions, setConditions] = useState({});
  const [activeTransitionList, setActiveTransitionList] = useState([]);

  useEffect(() => {
    // 条件データの取得
    BaseApi.get("get_conditions")
      .then((response) => {
        if (response?.data?.data?.condition) {
          setConditions(response.data.data.condition);
        }
      })
      .catch((error) => console.error("get_conditions error:", error));

    // アクティブマッチング一覧の取得
    BaseApi.get("active_matching")
      .then((response) => {
        setActiveMatchingList(response?.data?.data?.project_list || []);
      })
      .catch((error) => console.error("active_matching error:", error));

    // 新着マッチングの取得
    BaseApi.get("new_matching", {
      params: {
        cnt: 3,
      },
    })
      .then((response) => {
        const list = response?.data?.data?.matching_list || [];
        setNewMatchingList(list.slice(0, 3));
      })
      .catch((error) => console.error("new_matching error:", error));

    // お知らせの取得
    BaseApi.get("notifications", {
      params: {
        cnt: 10,
      },
    })
      .then((res) => {
        setNotification(res?.data?.data?.notification_list || []);
      })
      .catch((error) => console.error("notifications error:", error));

    // 昨日の日付を計算
    const today = new Date();
    today.setDate(today.getDate() - 1);
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const date = String(today.getDate()).padStart(2, "0");
    const referenceDate = `${year}-${month}-${date}`;

    // サマリーの取得
    BaseApi.get("top_summary", {
      params: {
        reference_date: referenceDate,
      },
    })
      .then((response) => {
        setTopSummaryList(response?.data?.data?.summary_list || []);
      })
      .catch((error) => console.error("top_summary error:", error));

    // 推移データの取得
    BaseApi.get("active_transition", {
      params: {
        reference_date: referenceDate,
      },
    })
      .then((response) => {
        const rawData = response?.data?.data;
        if (Array.isArray(rawData)) {
          const tempData = rawData.map((info) => {
            const week = info.acquisition_date
              ? info.acquisition_date.slice(5, 10).replace("-", "/")
              : "xx/xx";
            return { name: week + "週", 人: Number(info.receive_count || 0) };
          });
          setActiveTransitionList(tempData);
        }
      })
      .catch((error) => console.error("active_transition error:", error));
  }, [rerendering]);

  // Contextの参照をキャッシュ
  const contextValues = useMemo(
    () => ({
      newMatchingList,
      activeMatchingList,
      notification,
      topSummaryList,
      activeTransitionList,
      conditions,
    }),
    [
      newMatchingList,
      activeMatchingList,
      notification,
      topSummaryList,
      activeTransitionList,
      conditions,
    ]
  );

  const adminFlag = Number(localStorage.getItem("adminFlag"));
  const isValidUser =
    typeof localStorage.getItem("adminFlag") !== "undefined" && adminFlag !== -1;

  if (!isValidUser) {
    return <NotFound />;
  }

  return (
    <dashboardContext.Provider value={contextValues}>
      <DashboardTemplate />
    </dashboardContext.Provider>
  );
}

export default function Dashboard() {
  return <DashboardContent />;
}